export const FirmStatuses = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
} as const;

export const FirmStatusTitles = {
  [FirmStatuses.ACTIVE]: 'Active',
  [FirmStatuses.SUSPENDED]: 'Suspended',
} as const;

export const FirmStatusList = Object.values(FirmStatuses);
